import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequest } from "@utils/http-util";
import { injectRpServiceId } from "@utils/parameter-injector";
import { VerificationServiceChangeRequestResponse } from "@idw-types/data/verification-service";

type ArchiveVerificationServiceRequestResponse = {
    transferObject: VerificationServiceChangeRequestResponse;
};

export const archiveVerificationServiceRequest = async (
    verificationServiceId: string
): Promise<{ data: ArchiveVerificationServiceRequestResponse; error: any }> => {
    const route = injectRpServiceId(apiRoutes.serviceConfiguration.rpServiceConfig.rpService.archive, verificationServiceId);

    const { data, error } = await handleRequest(RequestTypes.POST, route);
    return { data, error };
};